import {Component} from '@angular/core';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {TenderDocumentModel} from '../../../models/tender-document.model';
import {UtilityService} from '../../../../../shared/services/utility.service';

@Component({
    selector: 'app-projects-project-documents-viewer',
    templateUrl: './project-documents-viewer.component.html',
    styleUrls: ['./project-documents-viewer.component.scss']
})
export class ProjectsProjectDocumentsViewerComponent extends EditModalSectionBaseComponent {

    public constructor(public editModalService: EditModalService,
                       private utilityService: UtilityService) {
        super(editModalService);
    }

    public onDocumentClicked(doc: TenderDocumentModel) {


        const blob = this.utilityService.b64toBlob(doc.fileContent);
        const data = window.URL.createObjectURL(blob);
        //
        const link = document.createElement('a');
        link.href = data;
        link.download = doc.fileName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));


        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    }


}
